export enum TimeOfDay {
    MORNING = 'morning',
    AFTERNOON = 'afternoon',
    EVENING = 'evening',
}
